import {
  CUSTOM_DOMAINS,
  CUSTOM_DOMAIN,
  CUSTOM_DOMAIN_CREATE,
  CUSTOM_DOMAIN_UPDATE,
  CUSTOM_DOMAIN_DELETE,
  CUSTOM_DOMAIN_VERIFY,
  CUSTOM_DOMAIN_DNS_INSTRUCTIONS
} from '@/store/actions/customDomains.actions';

const initialState = {
  custom_domains: [],
  current_custom_domain: null,
  dns_instructions: null,
  verification_steps: null,
  loading: false,
  error: null
};

export default function customDomains(state = initialState, action) {
  switch (action.type) {
    case CUSTOM_DOMAINS:
      return {
        ...state,
        custom_domains: action.payload.custom_domains || [],
        loading: false,
        error: null
      };
    case CUSTOM_DOMAIN:
      return {
        ...state,
        current_custom_domain: action.payload.custom_domain,
        loading: false,
        error: null
      };
    case CUSTOM_DOMAIN_CREATE:
      return {
        ...state,
        custom_domains: [action.payload.custom_domain, ...state.custom_domains],
        current_custom_domain: action.payload.custom_domain,
        loading: false,
        error: null
      };
    case CUSTOM_DOMAIN_UPDATE:
    case CUSTOM_DOMAIN_VERIFY:
      const updatedDomains = state.custom_domains.map(domain =>
        domain.id === action.payload.custom_domain.id ? action.payload.custom_domain : domain
      );
      return {
        ...state,
        custom_domains: updatedDomains,
        current_custom_domain: action.payload.custom_domain,
        loading: false,
        error: null
      };
    case CUSTOM_DOMAIN_DELETE:
      return {
        ...state,
        custom_domains: state.custom_domains.filter(domain => domain.id !== action.payload.id),
        current_custom_domain: null,
        loading: false,
        error: null
      };
    case CUSTOM_DOMAIN_DNS_INSTRUCTIONS:
      return {
        ...state,
        current_custom_domain: action.payload.custom_domain,
        dns_instructions: action.payload.dns_instructions,
        verification_steps: action.payload.verification_steps,
        loading: false,
        error: null
      };
    default:
      return state;
  }
}
